import { render, staticRenderFns } from "./PuiApprovePreview.vue?vue&type=template&id=5b92b8f3&xmlns%3Atable=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./PuiApprovePreview.vue?vue&type=script&lang=js"
export * from "./PuiApprovePreview.vue?vue&type=script&lang=js"
import style0 from "./PuiApprovePreview.vue?vue&type=style&index=0&id=5b92b8f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports